import { Upload, UploadProps } from 'antd';
import { UploadFile } from 'antd/es/upload/interface';
import { useAuthorization } from 'components/Authorization';
import { ReactNode, useState } from 'react';
import { getLeYanBotHost } from 'services/api/leyanBotHost';

type Value = Partial<Pick<Aide.WhatsAppMaterialHeader, 'example' | 'fileName' | 'previewUrl'>>;

interface UploadResponse {
  url: string;
  localUrl: string;
  thumbUrl: string;
}

export interface UploaderProps
  extends Omit<UploadProps<{ data: UploadResponse }>, 'value' | 'onChange'> {
  value: Value;
  onChange: (value: Value) => void;
  exampleField?: keyof UploadResponse;
  children?: ReactNode;
}

function Uploader(props: UploaderProps) {
  const { value, onChange, exampleField = 'url', children, ...otherProps } = props;

  const { token } = useAuthorization();

  const [fileList, setFileList] = useState<UploadFile[]>(() => {
    const { example, fileName, previewUrl } = value;

    if (!example || !fileName || !previewUrl) {
      return [];
    }

    return [
      {
        uid: example,
        name: fileName,
        fileName,
        thumbUrl: previewUrl,
        status: 'done',
      },
    ];
  });

  return (
    <Upload
      headers={{
        authorization: `Bearer ${token}`,
      }}
      action={`${getLeYanBotHost()}/oversea-door/oversea-wa-biz-home/uploadFile`}
      data={{ sendToWa: true }}
      fileList={fileList}
      onChange={({ fileList }) => {
        setFileList(fileList);

        const [file] = fileList;

        if (!file) {
          onChange({
            example: '',
            fileName: '',
            previewUrl: '',
          });

          return;
        }

        const { status, name, fileName = name, url, thumbUrl, response } = file;

        if (status === 'done' || status === 'success') {
          onChange({
            example: (response?.data || {})[exampleField] || url,
            fileName,
            previewUrl: response?.data?.thumbUrl || response?.data?.localUrl || thumbUrl,
          });
        }
      }}
      {...otherProps}
    >
      {fileList.length === 0 && children}
    </Upload>
  );
}

export default Uploader;
